module.exports = __webpack_public_path__ + "static/city-top-dark-1bd8aa87d5c40343b8a484e483c2d890.png";